import React, { useEffect, useRef, useState } from "react";
import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import { getValue } from "@utils/lodash";
import NoAccessPage from "@components/common/NoAccess";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { NavLink } from "react-router-dom";
import MoreReportSvgComponent from "../../../../assets/svg-components/left-menu/more-report";
import RightMenuHeaders from "@components/common/RightMenuHeaders";
import { Modal } from "reactstrap";
import InputField from "@_common/InputRuleFeild";
import SimpleReactValidator from "simple-react-validator";
import { months } from "@_common/month";
import { years } from "@_common/year";
import { toast } from "react-toastify";
import {
  createVendoAuditReport,
  getComplianceReports,
} from "@services/reports.service";
import { QueryRequestHelper } from "@_common/query-request-helper";
import { convertCurrentDate } from "@_common/date-helpers";
import { formatText } from "@_common/format-text";
import { handleDownloadOnClick } from "@_common/downloadfile";
import Loader from "@components/common/Loader";
import ScrollableReactTable from "@components/ScrollableDatatable";
import ReportsNotfoundPopup from "@components/Page-Not-Found/reports-not-found-popup";
import PaginationPage from "@components/pagination/pagination";
import { sanitizeInput } from "@_common/dompurify";
import { deleteExports } from "@services/import.service";

interface IVendorAuditReportProps {}

const VendorAuditReport: React.FunctionComponent<IVendorAuditReportProps> = (
  props: any
) => {
  let navigate = useNavigate();
  let mainParams = useParams();

  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */

  const [isLoading, setIsLoading] = React.useState(true);
  const [list, setList] = React.useState<[]>([]);
  const [check, setCheck] = useState(false);
  const [isOpen, setIsOpen] = useState<any>(false);
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  const handleAddFun = () => {
    handleModal();
  };
  const handleModal = () => {
    setIsOpen(!isOpen);
  };

  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length === 0 && props.permissionAPITriggered) {
      getData();
    }
  }, [props.permissionAPITriggered]);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
      getData();
      if (params.page_no) {
        setPage_no(parseInt(params.page_no));
      }
      if (params.limit) {
        setLimit(parseInt(params.limit));
      }
    }
  }, [window.location.href, props.permissionAPITriggered]);

  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */
  const getData = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    let payload: any = {
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      report_type: "VENDOR_AUDIT_REPORT",
      sort_by: params.sort_by,
    };
    let queryRequest = QueryRequestHelper(payload);
    try {
      setIsLoading(true);
      let resp = await getComplianceReports(queryRequest);
      if (resp) {
        setList(
          getValue(resp, `data.reports`, []).map((item: object) => ({
            ...item,
            created_at: getValue(item, `created_at`, "")
              ? convertCurrentDate(getValue(item, `created_at`, ""))
              : "",
            status: getValue(item, `is_active`, false) ? "Active" : "Inactive",
            report_type: formatText(getValue(item, `report_type`, "")),
            generated_by:
              getValue(item, `user.first_name`, "") +
              " " +
              getValue(item, `user.last_name`, ""),
          }))
        );
        setTotalCount(getValue(resp, `data.pagination.total`, 0));
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Pagination section                           */
  /* -------------------------------------------------------------------------- */

  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(100);
  const [page_no, setPage_no] = useState(1);

  const handleChangePagination = (page_no: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload = {
      ...params,
      page_no: page_no,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleChangeLimit = (limit: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      limit: limit,
      page_no: "1",
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const rowClick = (obj: object) => {};

  const getTrProps = (rowInfo: any) => {};

  const handleRemoveRecord = async (deleteId:any) => {
    try {
      const idsArray = Array.isArray(deleteId) ? deleteId : [deleteId];
      let resp = await deleteExports({ ids: idsArray });
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        getData();
      }
    } catch (error) {
      
    }
  }


  const columns = React.useMemo(
    () => [
      {
        Header: "Report Name",
        accessor: "report_name",
        width: 250,
        Cell: ({ row }: any) => {
          return (
            // <NavLink to={`/location/detail/${row.original.id}`}>
            <>{row.values.report_name}</>
            // </NavLink>
          );
        },
      },
      {
        Header: "Report Description",
        accessor: "report_description",
        width: 350,
      },
      {
        Header: "Report Type",
        accessor: "report_type",
        width: 150,
      },
      {
        Header: "Generated On",
        accessor: "created_at",
        width: 120,
      },
      {
        Header: "Generated By",
        accessor: "generated_by",
        width: 120,
      },
      {
        Header: "Download",
        width: 150,
        Cell: ({ row }: any) => {
          return (
            !row.original.is_verified && (
              <>
              <div className="table_download_container">
                <button
                  className="resend-btn d-flex align-items-center ms-0"
                  onClick={(e) =>
                    handleDownloadOnClick(
                      getValue(row, `original.report_url`, ""),
                      getValue(row, `original.report_name`, "")
                    )
                  }
                  style={{
                    color: getValue(row, `original.report_url`, "")
                      ? "#1A73E8"
                      : "black",
                  }}
                  disabled={!getValue(row, `original.report_url`, "")}
                >
                  {getValue(row, `original.report_url`, "") ? (
                    <img
                      src="/images/download.svg"
                      className="img-fluid d-block"
                    />
                  ) : (
                    <img
                      src="/images/clock.svg"
                      className="img-fluid d-block"
                      style={{
                        height: "18px",
                        width: "18px",
                        marginRight: "5px",
                      }}
                    />
                  )}
                  {getValue(row, `original.report_url`, "")
                    ? "Download"
                    : "Processing"}
                </button>
                {!getValue(row, `original.report_url`, "") &&
                  getValue(row, `original.status`, "") !== "Failed" && (
                    <img
                      src="/images/reload.svg"
                      className="img-fluid d-block"
                      style={{
                        height: "22px",
                        width: "22px",
                        marginLeft: "10px",
                      }}
                      onClick={() => getData()}
                    />
                  )}
              </div>

              {getValue(row, `original.queue_status`, "") !== "COMPLETED" ? 
                <button
                  className="resend-btn d-flex align-items-center ms-0 mt-1"
                  onClick={(e) =>
                    handleRemoveRecord(
                      getValue(row, `original.id`, "")
                    )
                  }
                  style={{ color: "#d7242e" }}
                >
                    <div className="d-flex align-items-center">
                      <img
                        src="/images/close-red.svg"
                        className="img-fluid d-block"
                      />
                      Remove
                    </div>
                </button>
              : ""}
              </>
            )
          );
        },
      },
    ],
    []
  );

  const [selectedIDs, setSelectedIDs] = useState<any>([]);
  const getTableState: any = (value: object) => {
    let selectedIndexList = Object.keys(
      getValue(value, `selectedRowIds`, {})
    ).map((item) => parseInt(item));
    let selectedIds =
      list.length > 0
        ? list.filter((_item: object, index: number) =>
            selectedIndexList.includes(index)
          )
        : [];
    if (selectedIds.length > 0) {
      setSelectedIDs(
        selectedIds.map((item: object) => getValue(item, `id`, ""))
      );
    } else {
      setSelectedIDs([]);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                             Report Add section                             */
  /* -------------------------------------------------------------------------- */

  const simpleValidator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useState(0);
  const [request, setRequest] = useState<any>({
    report_type: "VENDOR_AUDIT_REPORT",
    report_name: "",
    report_description: "",
    date_range: [{ month: "", year: "" }], // initialize with an empty object
  });

  const [submitLoading, setSubmitLoading] = useState(false);
  const handleSubmit = async () => {
    const formValid = simpleValidator.current.allValid();
    if (!formValid) {
      simpleValidator.current.showMessages();
      forceUpdate(1);
    } else {
      try {
        setSubmitLoading(true);
        let obj = JSON.parse(JSON.stringify(request));
        let payload = {
          report_type: "VENDOR_AUDIT_REPORT",
          report_name: getValue(obj, `report_name`, ""),
          report_description: getValue(obj, `report_description`, ""),
          date_range: getValue(obj, `date_range`, []),
        };
        let resp = await createVendoAuditReport(payload);
        if (resp) {
          toast.success(getValue(resp, `message`, ""));
          setSubmitLoading(false);
          getData();
          handleModal();
          setRequest({
            ...request,
            report_type: "VENDOR_AUDIT_REPORT",
            report_name: "",
            report_description: "",
            date_range: [{ month: "", year: "" }],
          });
        } else {
          setSubmitLoading(false);
        }
      } catch (error) {
        setSubmitLoading(false);
      }
    }
  };

  return (
    <>
      <DashboardLayout
        permissions={getValue(props, `tabPermissionList`, [])}
        subTabPermissionList={getValue(props, `subTabPermissionList`, [])}
      >
        {!isLoading &&
        !getValue(props, `subTabPermissionList`, []).includes(
          "report_analytics_fixed_report"
        ) ? (
          <NoAccessPage />
        ) : (
          <>
            <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <NavLink
                  to="/report/fixed-reports"
                  className="user-details-wrapper__header-back-link me-2"
                >
                  <img src="/images/back-link.svg" className="img-fluid" />
                </NavLink>
                <div className="header-parent-icon-holder">
                  <MoreReportSvgComponent />
                </div>

                <div className="title-wrapper">
                  <h6 className="dashbaord-wrapper__header-parent-title">
                    Reports
                  </h6>
                  <h4 className="dashbaord-wrapper__header-title">
                    Vendor Audit Reports
                  </h4>
                </div>
              </div>

              <div className="d-flex align-items-center">
                <RightMenuHeaders
                  route={"/report/vendor-audit/add"}
                  handleAddFun={() => handleAddFun()}
                  isAdd={
                    getValue(props, `permissions`, []).includes("create")
                      ? true
                      : false
                  }
                  add={
                    getValue(props, `permissions`, []).includes("create")
                      ? "true"
                      : "false"
                  }
                />
              </div>
            </div>
            <div
              className={`main-page-layout-wrapper`}
              id={
                getValue(selectedIDs, `length`, 0) > 0
                  ? "blueNavigationVisible"
                  : ""
              }
            >
              <div className="admin-wrapper position-relative">
                {isLoading || !props.permissionAPITriggered ? (
                  <Loader />
                ) : list.length > 0 ? (
                  <ScrollableReactTable
                    columns={columns}
                    data={list}
                    getTableState={getTableState}
                    rowClick={rowClick}
                    check={check}
                    selectedIDs={selectedIDs}
                    checkboxlogo
                    getTrProps={getTrProps}
                  />
                ) : (
                  <>
                    {Object.keys(params).length !== 0 ? (
                      <>
                        <ReportsNotfoundPopup
                          handleAddFun={() => handleAddFun()}
                        />
                      </>
                    ) : (
                      <ReportsNotfoundPopup
                        handleAddFun={() => handleAddFun()}
                      />
                    )}
                  </>
                )}
              </div>
              {totalCount != 0 && (
                <div className="footer-wrapper d-flex justify-content-between">
                  {list.length > 0 && (
                    <img
                      src="/images/building-illustration.svg"
                      className="img-fluid"
                    />
                  )}
                  {totalCount > 10 ? (
                    <PaginationPage
                      totalCount={totalCount}
                      limit={limit}
                      pageNumber={page_no}
                      handleChangePagination={handleChangePagination}
                      handleChangeLimit={handleChangeLimit}
                    />
                  ) : (
                    <></>
                  )}
                </div>
              )}
            </div>

            <Modal isOpen={isOpen} toggle={isOpen}>
              <section className="add-popup-wrapper">
                <div className="add-popup-wrapper__popup">
                  <div className="add-popup-wrapper__form-group form-group">
                    Vendor Audit Reports
                  </div>

                  <div className=" form-group">
                    <label htmlFor="title" className="rolls-label">
                      Report Name <span>*</span>
                    </label>
                    <InputField
                      inputType="TEXT"
                      placeholder="Enter Report Name"
                      label="Report Name"
                      className="form-control rolls-form-control"
                      id="title"
                      value={getValue(request, `report_name`, "")}
                      onChange={(e: any) =>
                        setRequest({
                          ...request,
                          report_name: sanitizeInput(e.target.value),
                        })
                      }
                      validator={simpleValidator}
                    />
                  </div>

                  <div className=" form-group">
                    <label htmlFor="title" className="rolls-label">
                      Report Description <span></span>
                    </label>
                    <InputField
                      inputType="TEXT"
                      placeholder="Enter Report Description"
                      label="Report Description"
                      className="form-control rolls-form-control"
                      id="title"
                      value={getValue(request, `report_description`, "")}
                      onChange={(e: any) =>
                        setRequest({
                          ...request,
                          report_description: sanitizeInput(e.target.value),
                        })
                      }
                    />
                  </div>

                  <div className="form-group ">
                    <label htmlFor="title" className="rolls-label">
                      Date Range
                    </label>
                    {request.date_range.map(
                      (
                        dateRange: { month: string; year: string },
                        index: number
                      ) => (
                        <div
                          key={index}
                          className="d-flex w-100 gap-4 vendor-audit-report-dyno-wrap align-items-center"
                        >
                          <div className="report-dyno-dp">
                            <InputField
                              inputType="INPUT_REACT_SELECT"
                              placeholder="Choose Month"
                              className="form-control w-100"
                              name="state_id"
                              id="state_id"
                              options={months}
                              value={months.filter(
                                (item: any) =>
                                  getValue(item, `value`, "") ==
                                  getValue(dateRange, `month`, "")
                              )}
                              onChange={(e: any) =>
                                setRequest({
                                  ...request,
                                  date_range: request.date_range.map(
                                    (dr: any, i: any) =>
                                      i === index
                                        ? {
                                            ...dr,
                                            month: parseInt(
                                              getValue(e, `value`, "")
                                            ),
                                          }
                                        : dr
                                  ),
                                })
                              }
                              isClear
                              validator={simpleValidator}
                              label={"Month"}
                            />
                          </div>

                          <div className="report-dyno-dp">
                            <InputField
                              inputType="INPUT_REACT_SELECT"
                              placeholder="Choose Year"
                              className="form-control w-100"
                              name="state_id"
                              id="state_id"
                              options={years}
                              value={years.filter(
                                (item: any) =>
                                  getValue(item, `value`, "") ==
                                  getValue(dateRange, `year`, "")
                              )}
                              onChange={(e: any) =>
                                setRequest({
                                  ...request,
                                  date_range: request.date_range.map(
                                    (dr: any, i: any) =>
                                      i === index
                                        ? {
                                            ...dr,
                                            year: getValue(e, `value`, ""),
                                          }
                                        : dr
                                  ),
                                })
                              }
                              label={"Year"}
                              isClear
                              validator={simpleValidator}
                            />
                          </div>

                          {index > 0 && (
                            <span
                              className="remove-icon cursor-pointer"
                              onClick={() =>
                                setRequest({
                                  ...request,
                                  date_range: request.date_range.filter(
                                    (_: any, i: any) => i !== index
                                  ),
                                })
                              }
                            >
                              <img src="/images/close-black.svg" />
                            </span>
                          )}
                        </div>
                      )
                    )}

                    <a
                      href="#"
                      onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
                        e.preventDefault();
                        setRequest({
                          ...request,
                          date_range: [
                            ...request.date_range,
                            { month: "", year: "" },
                          ],
                        });
                      }}
                      className="mt-2"
                    >
                      <div className="d-flex align-items-center">
                        Add New {""}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="24"
                          width="24"
                        >
                          <path
                            d="M11 19V13H5V11H11V5H13V11H19V13H13V19Z"
                            fill="#0d6efd"
                          />
                        </svg>
                      </div>
                    </a>
                  </div>

                  <div className="add-popup-wrapper__cta-wrapper">
                    <button
                      onClick={handleModal}
                      className="add-popup-wrapper__cta-btn add-popup-wrapper__cta-btn--secondary"
                    >
                      Cancel
                    </button>
                    <button
                      className="add-popup-wrapper__cta-btn add-popup-wrapper__cta-btn--primary"
                      onClick={handleSubmit}
                      disabled={submitLoading}
                    >
                      {submitLoading ? "Please Wait..." : "Submit"}
                    </button>
                  </div>
                </div>
              </section>
            </Modal>
          </>
        )}
      </DashboardLayout>
    </>
  );
};

export default VendorAuditReport;
